import React, { FC } from "react";
import Icon from "newComponents/Shared/_Atoms/Icons/Icon/Icon";
import Portal from "layout/Portal/Portal";
import colors from "constants/colors";

interface IProps {
  image: string;
  onClose: () => void;
}

const FullscreenImage: FC<IProps> = ({ image, onClose }) => {
  const env = process.env.BUILD;
  return (
    <Portal id="full-screen-image" onClose={onClose}>
      <div className="fullscreen-image-container">
        <div className="modal-content">
          <Icon
            icon="close"
            onClick={onClose}
            className="fullscreen-image-close-button"
            color={colors.black}
          />
          <img
            src={`${env !== "dev" ? "/admin" : ""}/static/images/${image}`}
            alt={"fullscreen-image"}
          />
        </div>
      </div>
    </Portal>
  );
};

export default FullscreenImage;
